import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Button, IconButton, Typography } from '@mui/material';
import { FileAddIcon } from '@sharedCR/coreDesignSystem/icons';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';
import { MarkedAppFormsTreeFieldId } from 'app/services/autoLockForms/autoLockForms.fieldIds';
import PropType from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import {
  selectFormHiddenFieldsMap,
  selectFormLockedFieldsMap,
  selectFormLockedPage,
} from 'store/loanApplications/selectors';
import { selectFormHiddenPage } from 'store/loanApplications/selectors/lockedFields.selectors';

import { ActivitiesTestIds } from '../../Activities.testIds';

const NewEmailFooter = ({ isLoading, onAttachFile, filesAmount }) => {
  const lockedFieldsMap = useSelector(selectFormLockedFieldsMap(FormNames.ACTIVITIES_EMAILS));
  const hiddenFieldsMap = useSelector(selectFormHiddenFieldsMap(FormNames.ACTIVITIES_EMAILS));
  const isPageLocked = useSelector(selectFormLockedPage(FormNames.ACTIVITIES_EMAILS));
  const isPageHidden = useSelector(selectFormHiddenPage(FormNames.ACTIVITIES_EMAILS));

  const isDisabledByLock = isLoading || isPageLocked;

  return (
    <div className="w-full flex justify-between p-12">
      <div className="flex items-center space-x-6">
        <IconButton
          data-field-id={MarkedAppFormsTreeFieldId.ACTIVITIES_EMAIL_FILES}
          data-testid={ActivitiesTestIds.ATTACH_FILE_BUTTON}
          disabled={isDisabledByLock || lockedFieldsMap.files}
          isHidden={hiddenFieldsMap.files || isPageHidden}
          size="small"
          onClick={onAttachFile}
        >
          <FileAddIcon size={IconSize[20]} />
        </IconButton>
        {!!filesAmount && (
          <Typography variant="regular14">{filesAmount} file(s) attached</Typography>
        )}
      </div>
      <Button
        data-testid={ActivitiesTestIds.SEND_BUTTON}
        disabled={isLoading}
        size="small"
        type="submit"
        variant="contained"
      >
        Send
      </Button>
    </div>
  );
};

NewEmailFooter.propTypes = {
  filesAmount: PropType.number.isRequired,
  isLoading: PropType.bool.isRequired,
  onAttachFile: PropType.func.isRequired,
};

export default memo(NewEmailFooter);
